import { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Generate a simple user object from token
  const createUserFromToken = (tokenString) => {
    if (!tokenString) return null;

    // For demo, we'll just create a user with the token
    // In a real app, you would validate the token and extract user info from it
    return {
      id: 'user' + Math.floor(Math.random() * 1000),
      email: 'user@example.com', // Default email since we don't store it in the token
      name: 'User',
      role: 'admin',
      token: tokenString
    };
  };

  useEffect(() => {
    // Check for token in sessionStorage
    const tokenString = sessionStorage.getItem('token');
    if (tokenString) {
      const userData = createUserFromToken(tokenString);
      setUser(userData);
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    // Store the token in sessionStorage
    sessionStorage.setItem('token', token);

    // Set user data in memory
    setUser({
      ...userData,
      token: token
    });
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
